(() => {
  const SECTION = ".shopify-section--youp-home-hero";

  function inlineSvgIcon(img) {
    const url = (img.currentSrc || img.src || "").split("#")[0];
    if (!url || !url.toLowerCase().includes(".svg")) return;

    const wrap = img.closest(".youp-home-hero__btn-icon");
    if (!wrap || wrap.querySelector("svg")) return;

    fetch(url, { mode: "cors", credentials: "omit" })
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.text();
      })
      .then((text) => {
        const trimmed = text.trim().replace(/^\uFEFF/, "");
        if (!trimmed.includes("<svg")) return;

        const doc = new DOMParser().parseFromString(trimmed, "image/svg+xml");
        const svg = doc.querySelector("svg");
        if (!svg) return;

        svg.removeAttribute("width");
        svg.removeAttribute("height");

        const applyCurrent = (el) => {
          ["fill", "stroke"].forEach((attr) => {
            const v = el.getAttribute(attr);
            if (!v || v === "none" || v === "transparent" || v.startsWith("url(")) return;
            el.setAttribute(attr, "currentColor");
          });
        };

        applyCurrent(svg);
        svg.querySelectorAll("*").forEach((n) => {
          if (n.tagName && n.tagName.toLowerCase() === "style") return;
          applyCurrent(n);
        });

        svg.classList.add("youp-home-hero__btn-icon-svg");
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");

        wrap.replaceChildren(svg);
      })
      .catch(() => {
      });
  }

  function init(root) {
    root.querySelectorAll(".youp-home-hero__actions .youp-home-hero__btn-icon-image").forEach(inlineSvgIcon);
  }

  function onReady() {
    document.querySelectorAll(SECTION).forEach((el) => init(el));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  document.addEventListener("shopify:section:load", (e) => {
    if (e.target?.matches?.(SECTION)) init(e.target);
  });
})();
